import { SchemaConvertor } from './schema.convertor';
import { TransformConvertorBase } from './transform.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { ExtendTransformation } from 'app/model/dataflow/extendtransformation';
import { ExtendPlainObject } from 'worker/app-workers/shared/plainObjects/extend.plainObject';
import { IResourceContext } from 'shell-models-lib';

export class ExtendConvertor extends TransformConvertorBase {
    private get extendTransform(): ExtendTransformation {
        return this.transformation as ExtendTransformation;
    }

    private get extendObject(): ExtendPlainObject {
        return this.transformObject as ExtendPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        this.extendTransform.schema = SchemaConvertor.convertColumnsFromPlainObject(this.extendObject.columns, this.extendTransform);

        if (this.extendObject.configs.has('method')) {
            const method = this.extendObject.configs.get('method');
            this.extendTransform.method = method.substring(1, method.length - 1);
            this._handledConfigs.push('method');
        }

        super.postConvert();
        return this.extendTransform;
    }
}
